<template>
  <div>
    <ul class="animate-lists">
      <li
        v-for="(animate, index) in animates"
        :key="index"
        @click="changeAnimateStyle(animate)"
        :class="animateType === animate.animateType ? 'active' : ''"
      >
        <div class="animate-img-box">
          <img class="animate-img" :src="animate.iconUrl" />
        </div>
        <p>{{ animate.name }}</p>
      </li>
    </ul>
    <div v-if="animateType">
      <div class="verticallyCenter mb12 directions-box" v-if="showDirection">
        <cx-select
          class="effect-select flex1"
          title="方向"
          :showIcon="true"
          :selectOptions="directions"
          :selectDirection="selectDirection"
          @change="animatesOfInChange"
          :value.sync="animateVal.direction"
        />
      </div>
      <div class="mb12 directions-box" v-if="showXY">
        <slider-and-input
          class="mb12"
          inputWidth="small"
          inputHeight="small"
          :value.sync="moveX"
          title="X轴"
          titlePosition="allInOneLine"
          :sliderMax="1000"
          :sliderMin="-1000"
          suffix="px"
        />
        <slider-and-input
          class="mb12"
          inputWidth="small"
          inputHeight="small"
          :value.sync="moveY"
          title="Y轴"
          titlePosition="allInOneLine"
          :sliderMax="1000"
          :sliderMin="-1000"
          suffix="px"
        />
      </div>
      <!--      <slider-and-input-->
      <!--        class="mb12"-->
      <!--        inputWidth="small"-->
      <!--        inputHeight="small"-->
      <!--        :value.sync="animateVal.animateDuration"-->
      <!--        title="持续"-->
      <!--        titlePosition="allInOneLine"-->
      <!--        :sliderMax="10000"-->
      <!--        suffix="ms"-->
      <!--      />-->
      <slider-and-input
        class="mb12"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        :ratio="1000"
        suffix="s"
      />
      <slider-and-input
        class="mb12"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        :ratio="1000"
        suffix="s"
      />
      <cx-check-box class="mt12" :value.sync="isRepeat">循环动画</cx-check-box>
    </div>
  </div>
</template>

<script>
export default {
  name: "animateGroupSet",
  props: {
    animateGroup: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      animates: [
        {
          name: "无",
          animateType: "",
          animateClass: "",
          direction: null,
          animateDuration: 1000, //单位ms
          animateDelay: 0,
          iconUrl: require("assets/images/animate_icon/none1.png")
        },
        {
          name: "淡入",
          animateType: "fade-in",
          animateClass: "fade-in",
          direction: "",
          animateDuration: 1000, //单位ms
          animateDelay: 0,
          iconUrl: require("assets/images/animate_icon/fadeIn.png")
        },
        {
          name: "翻转",
          animateType: "flip",
          animateClass: "flip",
          direction: "horizontal-top",
          animateDuration: 1000, //单位ms
          animateDelay: 0,
          iconUrl: require("assets/images/animate_icon/overturn1.png")
        },
        {
          name: "移动",
          animateType: "move",
          animateClass: "move",
          // direction: "",
          directionParameter: { x: "10px", y: "10px" },
          animateDuration: 1000, //单位ms
          animateDelay: 0,
          iconUrl: require("assets/images/animate_icon/move.png")
        }
      ],
      fadeInDirections: [
        {
          icon: "icon-portal-not-allowed",
          label: "无",
          value: ""
        },
        {
          icon: "icon-portal-direction-right",
          label: "从左往右",
          value: "left"
        },
        {
          icon: "icon-portal-direction-left",
          label: "从右往左",
          value: "right"
        },
        {
          icon: "icon-portal-direction-up",
          label: "从下往上",
          value: "down"
        },
        {
          icon: "icon-portal-direction-down",
          label: "从上往下",
          value: "up"
        },
        {
          icon: "icon-portal-direction-rd",
          label: "从左上开始",
          value: "left-up"
        },
        {
          icon: "icon-portal-direction-ld",
          label: "从右上开始",
          value: "right-up"
        },
        {
          icon: "icon-portal-direction-ru",
          label: "从左下开始",
          value: "left-down"
        },
        {
          icon: "icon-portal-direction-lu",
          label: "从右下开始",
          value: "right-down"
        }
      ],
      flipDirections: [
        {
          icon: "icon-portal-direction-down",
          label: "从上往下",
          value: "horizontal-top"
        },
        {
          icon: "icon-portal-direction-up",
          label: "从下往上",
          value: "horizontal-bottom"
        },
        {
          icon: "icon-portal-direction-right",
          label: "从左往右",
          value: "vertical-left"
        },
        {
          icon: "icon-portal-direction-left",
          label: "从右往左",
          value: "vertical-right"
        }
      ]
    }
  },
  computed: {
    animateVal: {
      get() {
        return this.animateGroup
      },
      set(newVal) {
        this.$emit("update:animateGroup", newVal)
      }
    },
    showDirection() {
      return this.animateVal && this.animateVal.hasOwnProperty("direction")
    },
    showXY() {
      let directionParameter = this.animateVal.directionParameter
      if (directionParameter && (directionParameter.hasOwnProperty("x") || directionParameter.hasOwnProperty("y"))) {
        return true
      }
      return false
    },
    isRepeat:{
      get() {
        return this.animateVal.isRepeat || false
      },
      set(val) {
        this.$set(this.animateVal,"isRepeat",val)
        this.$emit("update:animateGroup", this.animateVal)
      }
    },
    selectDirection() {
      return this.directions.find(item => item.value === this.animateVal.direction)?.icon
    },
    directions() {
      let directions = []
      switch (this.animateType) {
        case "fade-in":
          directions = this.fadeInDirections
          break
        case "flip":
          directions = this.flipDirections
          break
        default:
      }
      return directions
    },
    animateType() {
      return this.animateGroup && this.animateGroup.animateType ? this.animateGroup.animateType : ""
    },
    animateDuration: {
      get() {
        return this.animateVal.animateDuration / 1000
      },
      set(val) {
        this.animateVal.animateDuration = val * 1000
      }
    },
    moveX:{
      get() {
        if(this.animateVal?.directionParameter?.hasOwnProperty("x")){
          return parseInt(this.animateVal.directionParameter.x)
        }
      },
      set(val) {
        this.$set(this.animateVal.directionParameter,"x",val+"px")
      }
    },
    moveY:{
      get() {
        if(this.animateVal?.directionParameter?.hasOwnProperty("y")){
          return parseInt(this.animateVal.directionParameter.y)
        }
      },
      set(val) {
        this.$set(this.animateVal.directionParameter,"y",val+"px")
      }
    }
  },
  methods: {
    changeAnimateStyle(animate) {
      let tempData = JSON.parse(JSON.stringify(animate))
      delete tempData.iconUrl
      this.animateVal = animate
    },
    selectAnimateDirection() {},
    animatesOfInChange() {}
  }
}
</script>

<style lang="scss" scoped>
.animate-lists {
  display: flex;
  flex-wrap: wrap;

  > li {
    width: 68px;
    margin: 0 12px 16px 0;
    text-align: center;
    color: var(--subTextColor);
    cursor: pointer;

    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      .animate-img-box {
        border: 1px solid var(--themeColor);
      }
    }
    &.active {
      .animate-img-box {
        border: 2px solid var(--themeColor);
      }
    }
    .animate-img-box {
      overflow: hidden;
    }
  }

  .animate-img-box {
    display: inline-block;
    width: 68px;
    height: 68px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    margin-bottom: 4px;
    box-sizing: border-box;

    .animate-img {
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep .effect-select .el-input .el-input__inner {
  padding-left: 34px;
}
</style>